import EditRecordsModal from './EditRecordsModal';

export default EditRecordsModal;
